import { useEffect, useState } from "react";

export function useCurrentTime(intervalMs = 1000): Date {
  // Initialize with the current time
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    // Set up interval to update time
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, intervalMs);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [intervalMs]);

  return time;
}
